import React from 'react'
import capitalize from 'lodash/capitalize'
import { Text, Button } from '@components/UI'
import { Classroom as ClassroomConstants } from '@constants'
import { useClassroomEnv } from '@components/ClassroomEnv'
import { useClassroomPermissions } from '../../contexts'

const Fallback = ({ create, type }) => {
  const { env } = useClassroomEnv()
  const { checkPermission } = useClassroomPermissions()

  switch (env) {
    case ClassroomConstants.ENV.PLAYGROUND:
    case ClassroomConstants.ENV.CLASSROOM:
    case ClassroomConstants.ENV.SKETCHPAD:
      return (
        <div className='gp-frame-fallback'>
          <Text className='color-f text-i'>
            There are no active {type} files
          </Text>

          {checkPermission(ClassroomConstants.FEATURES.TOOL_NEW_FILE) ? (
            <>
              <Text className='color-f text-i'>
                Let&apos;s create a new one
              </Text>
              <Button
                style={{ marginTop: 20 }}
                theme='f interactive'
                group='a4'
                icon={{
                  name: 'plus',
                  value: `Create ${type.charAt(0).toUpperCase()}${type.slice(
                    1
                  )}`,
                  group: 'a2'
                }}
                events={{
                  onClick: create
                }}
              />
            </>
          ) : null}
        </div>
      )
    case ClassroomConstants.ENV.RECORDING:
      return (
        <div className='gp-frame-fallback'>
          <Text className='color-f text-i'>
            {capitalize(type)} files will appear here
          </Text>
        </div>
      )
    default:
      return null
  }
}

export default Fallback
